module.exports = __webpack_public_path__ + "static/media/img-message-reason@3x.cd824434.png";